import {I18n} from '@aws-amplify/core';

import {SimplePageHeader} from '@flexinet/ui-components';

import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from '../../../config/rbac/actions';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton';
import {AddRecordButton} from '../buttons/AddRecordButton';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton';

const useTools = (selectedIds: string[], onDeleteComplete?: () => void) => {

    const {allowedActions} = useVerifiedPermissions();

    // Order is [Reload, Filter] then Delete/Add — matching the sibling
    // modules in this app (§2). Filter and Reload are ungated: both act on
    // the list the operator can already see.
    const tools = [
        <ReloadRecordsButton key='reload'/>,
        <FilterRecordsButton key='filter'/>,
    ];

    if (allowedActions.includes(rbacActions.DeletePaymentIntent)) {
        tools.push(
            <DeleteRecordButton
                key='delete'
                selectedIds={selectedIds}
                onDeleteComplete={onDeleteComplete}
            />,
        );
    }

    if (allowedActions.includes(rbacActions.CreatePaymentIntent)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

interface IndexPageHeaderProps {
    selectedIds?: string[];
    onDeleteComplete?: () => void;
}

export const IndexPageHeader = ({
                                    selectedIds = [],
                                    onDeleteComplete,
                                }: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Payment Intents')}
            tools={useTools(selectedIds, onDeleteComplete)}
        />
    );
};
